import script from "./promotionalVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./promotionalVideo.vue?vue&type=script&setup=true&lang=js"

import "./promotionalVideo.vue?vue&type=style&index=0&id=7e8dfe99&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6558ed2e51dee85cd0a9e429c286fa8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e8dfe99"]])

export default __exports__